import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { agendaFeedApi } from "../api/agendaFeedApi";

const QUERY_KEY = ["perfil", "agenda-feed"];

export function useAgendaFeedQuery() {
  return useQuery({ queryKey: QUERY_KEY, queryFn: agendaFeedApi.getStatus });
}

// As três ações devolvem o novo estado do feed — grava direto no cache em vez de refazer
// a consulta.
function useAgendaFeedMutation(mutationFn) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: (dados) => queryClient.setQueryData(QUERY_KEY, dados),
  });
}

export const useAtivarAgendaFeedMutation = () => useAgendaFeedMutation(agendaFeedApi.ativar);
export const useRegenerarAgendaFeedMutation = () => useAgendaFeedMutation(agendaFeedApi.regenerar);
export const useDesativarAgendaFeedMutation = () => useAgendaFeedMutation(agendaFeedApi.desativar);
